module.exports = __webpack_public_path__ + "static/media/publications.0ec3380b.png";